const hotels = {
  back: "Zurück", // translated
  rooms: "Räume", // translated
  viewPictures: "Bilder ansehen", // translated
  showMore: "Zeig mehr", // translated
  bookingInformation: "Buchungsinformation", // translated
  cancellationPolicy: "Stornierungsbedingungen", // translated
  from: "Aus", // translated
  to: "zu", // translated
  cancellationIs: "Stornierung ist", // translated
  free: "frei", // translated
  chargeableWithFeeOf: "kostenpflichtig mit einer Gebühr von", // translated
  prebook: "Vorbestellen", // translated
  guests: "Gäste", // translated
  payment: "Zahlung", // translated
  byClicking: "Beim Klicken", // translated
  next: "Nächste", // translated
  youAreAgreeingToOur: "Sie stimmen unseren zu", // translated
  termsAndConditions: "Geschäftsbedingungen", // translated
  previous: "Bisherige", // translated
  cancel: "Absagen", // translated
  mealPlan: "Essensplan", // translated
  roomType: "Zimmertyp", // translated
  description: "Beschreibung", // translated
  readLess: "Lese weniger", // translated
  readMore: "Weiterlesen", // translated
  facilities: "Einrichtungen", // translated
  viewLess: "Weniger anzeigen", // translated
  viewMore: "Mehr sehen", // translated
  less: "weniger", // translated
  more: "mehr", // translated
  notAvailable_short: "N / A", // translated
  backToHotelList: "Zurück zur Hotelliste", // translated
  viewOnMap: "Auf Karte anzeigen", // translated
  sleeps: "Schläft", // translated
  adults: "Erwachsene", // translated
  yearsOld: "Jahre alt", // translated
  type: "Typ", // translated
  bedding: "Bettwäsche", // translated
  selectRoom: "Zimmer auswählen", // translated
  city: "Stadt", // translated
  checkIn: "Check-In", // translated
  checkOut: "Kasse", // translated
  date: "Datum", // translated
  persons: "Personen", // translated
  stillOnTrialQuestionToUpgrade: "Hoppla! Anscheinend haben Sie noch eine Probemitgliedschaft. Sie müssen ein bestätigtes Mitglied sein, um Buchungen vornehmen zu können. Möchten Sie jetzt upgraden?", // translated
  stillOnTrialQuestionToUpgradeNonElligib: "Hoppla! Anscheinend hast du noch kein Abo. Sie müssen ein bestätigtes Mitglied sein, um Buchungen vornehmen zu können. Möchten Sie jetzt upgraden?", // translated
  completeProfile: "Bitte vervollständigen Sie zuerst Ihr Benutzerprofil", // translated
  upgrade: "Aktualisierung", // translated
  close: "Schließen", // translated
  viewDetails: "Details anzeigen", // translated
  name: "Name", // translated
  rating: "Bewertung", // translated
  budget: "Budget", // translated
  orderBy: "Sortieren nach", // translated
  priceLowestFirst: "Preis: niedrigster zuerst)", // translated
  priceHighestFirst: "Preis: höchster zuerst)", // translated
  ratingLowestFirst: "Bewertung (niedrigste zuerst)", // translated
  ratingHighestFirst: "Bewertung (höchste zuerst)", // translated
  starRatingAndPrice: "Sternebewertung und Preis", // translated
  select: "Auswählen", // translated
  reset: "Zurücksetzen", // translated
  apply: "Anwenden", // translated
  filterBy: "Filtern nach", // translated
  myProfile: "Mein Profil", // translated
  login: "Anmeldung", // translated
  roomOnly: "Nur Zimmer", // translated
  bedAndBreakfast: "Bed & Breakfast", // translated
  halfBoard: "Halbpension", // translated
  fullBoard: "Vollpension", // translated
  allInclusive: "Alles inklusive", // translated
  filter: "Filter", // translated
  mapView: "Kartenansicht", // translated
  results: "Ergebnisse", // translated
  listView: "Listenansicht", // translated
  newSearch: "Neue Suche", // translated
  editSearch: "Suche bearbeiten", // translated
  all: "Alles", // translated
  multiple: "Mehrere", // translated
  editProfile: "Profil bearbeiten", // translated
  backToHotelsList: "Zurück zur Hotelliste", // translated
  roomName: "Raumname", // translated
  mealType: "Art der Mahlzeit", // translated
  freeCancellation: "Kostenfreie Stornierung", // translated
  yes: "Ja", // translated
  no: "Nein", // translated
  filters: "Filter", // translated
  cancellationNonRefundable: "Die Stornierung ist nicht erstattungsfähig", // translated
  biggestSavingsFirst: "Die größten Einsparungen zuerst", // translated
  hotel: "Hotel", // translated
  performNewSearch: "Führen Sie eine neue Suche durch", // translated
  off: "Aus", // translated
  any: "Beliebig", // translated
  accommodation: "Unterkunft", // translated
  hotelRating: "Hotelbewertung", // translated
  dates: "Termine", // translated
  hotels: "Hotels", // translated
  selectRooms: "Wählen Sie Räume aus", // translated
};


export default hotels;
